import { render, staticRenderFns } from "./OrderCommuter.vue?vue&type=template&id=6b1412bc&scoped=true"
import script from "./OrderCommuter.vue?vue&type=script&lang=js"
export * from "./OrderCommuter.vue?vue&type=script&lang=js"
import style0 from "./OrderCommuter.vue?vue&type=style&index=0&id=6b1412bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1412bc",
  null
  
)

export default component.exports